import { createContext, PropsWithChildren, useContext, useMemo } from 'react';
import { useRouteMatch } from 'react-router';
import { r } from 'shared/constants/routes';

interface ISharingContext {
	sharingId: string;
}

export const SharingContext = createContext<ISharingContext>({ sharingId: '' });

export default function SharingProvider({ children }: PropsWithChildren) {
	const match = useRouteMatch<{ sharingId?: string }>(r.share.path);
	const { sharingId } = match?.params ?? {};
	console.log('tst: sharingId', { sharingId });

	const value = useMemo(() => ({
		sharingId: sharingId || '',
	}), [sharingId]);

	return <SharingContext.Provider value={value}>{children}</SharingContext.Provider>;
}

export const useSharingContext = (): ISharingContext => useContext(SharingContext);
